import React from 'react'

import Icon from 'components/Icon'

import ContentfulDocument from '../ContentfulDocument/ContentfulDocument'

import classes from './LegalPageAlert.module.scss'

export default ({ heading, content }) => {
  const hasHeading = !!heading

  const containerClassname = `${classes.container} ${hasHeading ? classes.containerWithHeading : ''}`

  return (
    <div className={containerClassname}>
      {hasHeading ? (
        <div className={classes.heading}>
          {heading} <Icon className={classes.inlineIcon} prefix="far" icon="circle-info" size="14" />
        </div>
      ) : (
        <div className={classes.icon}>
          <Icon prefix="far" icon="circle-info" size="12" />
        </div>
      )}

      <div className={classes.content}>
        <ContentfulDocument content={content} />
      </div>
    </div>
  )
}
